export default "__VITE_ASSET__BuXoHUqi__"